<div #masterFormContainer id="master-form-container" class="master-container"
  [class.absolute-position]="absolutePosition" data-cy="forms-form-master-container">  
  <div class="pdf-cover" *ngIf="generatingPdf" data-cy="forms-form-generating-pdf-cover">
    <div class="pdf-header" data-cy="forms-form-pdf-header">
      Generating PDF
    </div>
    <div class="spinner-holder" data-cy="forms-form-pdf-spinner-holder">
      <mat-spinner data-cy="forms-form-pdf-spinner"></mat-spinner>
    </div>
  </div>
  <div class="pdf-cover" *ngIf="hoverLoading" data-cy="forms-form-hover-loading-cover">
    <div class="spinner-holder" data-cy="forms-form-hover-spinner-holder">
      <mat-spinner data-cy="forms-form-hover-spinner"></mat-spinner>
    </div>
  </div>
  <div class="main-container" *ngIf="(!isLoading && dataForm)" id="main-form-container"
    [class.generatingPdf]="generatingPdf" data-cy="forms-form-main-container">
    <div *ngIf="isFormLocked && !generatingPdf" style="display: flex;justify-content: center;" data-cy="forms-form-locked-message">
      <button *ngIf="isFormLocked" [disabled]="true" class="tdo-button tdo-save" data-cy="forms-form-locked-button">Form already Completed</button>
    </div>
    <ng-container *ngIf="hasPageBreak">

      <app-tdo-accordion [allowMultiple]="false" data-cy="forms-form-accordion">
        <app-tdo-accordion-item *ngFor="let paragraphGroup of pageBreakArray; let i = index;"
          [isExpanded]="paragraphStep === i" (opened)="setParagraphStep(i)"
          data-cy="forms-form-accordion-item-{{i}}">
          <app-tdo-accordion-item-header data-cy="forms-form-accordion-header-{{i}}">Section {{ i+1 }}</app-tdo-accordion-item-header>
          <app-tdo-accordion-item-content data-cy="forms-form-accordion-content-{{i}}">
            <div style="display: flex; width: 100%; flex: 1; flex-flow: column;" data-cy="forms-form-paragraphs-container-{{i}}">
              <app-forms-paragraph style="margin: 2px;" *ngFor="let paragraph of paragraphGroup; let j = index"
                [dataForm]="dataForm" (saveDataNoteEvent)="onSaveDataNote($event)"
                [containerDimensions]="containerDimensions" [paragraphIndex]="j" [hasPageBreak]="false"
                [CaseWorkItemFormsId]="CaseWorkItemFormsId" [actionsEnabled]="actionsEnabled" [dataFormID]="dataFormID"
                [colorGuides]="colorGuides" [saveEmitter]="saveEmitter" [relatedRepeatingParagraph]="repeatingParagraph"
                [dataFormParagraph]="paragraph"
                data-cy="forms-form-paragraph-{{i}}-{{j}}">
              </app-forms-paragraph>
            </div>
          </app-tdo-accordion-item-content>
        </app-tdo-accordion-item>
      </app-tdo-accordion>
    </ng-container>
    <ng-container *ngIf="!hasPageBreak">
      <div style="display: flex; width: 100%; flex: 1; flex-flow: column;" data-cy="forms-form-paragraphs-container">
        <app-forms-paragraph style="margin: 2px;" *ngFor="let paragraph of dataForm.dataFormParagraphs; let i = index"
          [dataForm]="dataForm" (saveDataNoteEvent)="onSaveDataNote($event)" [containerDimensions]="containerDimensions"
          [paragraphIndex]="i" [hasPageBreak]="false" [CaseWorkItemFormsId]="CaseWorkItemFormsId"
          [actionsEnabled]="actionsEnabled" [dataFormID]="dataFormID" [colorGuides]="colorGuides"
          [saveEmitter]="saveEmitter" [relatedRepeatingParagraph]="repeatingParagraph" [dataFormParagraph]="paragraph"
          data-cy="forms-form-paragraph-{{i}}">
        </app-forms-paragraph>

      </div>
    </ng-container>
    <div class="section-footer" style="flex-basis: 46px; padding-top: 6px; margin:auto"
      *ngIf="!generatingPdf && (dataForm.cfgDForm?.isSubmissionRequired || dataForm.isSubmissionRequired)"
      data-cy="forms-form-footer">
      <div style="margin: auto;" data-cy="forms-form-footer-buttons">
        <button *ngIf="!isFormLocked" (click)="completeForm()" [disabled]="itemsRequired.size > 0" class="tdo-button tdo-save" data-cy="forms-form-complete-button">Complete Form</button>
        <button *ngIf="isFormLocked" [disabled]="true" class="tdo-button tdo-save" data-cy="forms-form-already-completed-button">Form already Completed</button>
      </div>
    </div>
  </div>
  <div class="spinnder-div" *ngIf="isLoading && CaseWorkItemFormsId" data-cy="forms-form-loading-container">
    <div class="spinner-holder" data-cy="forms-form-loading-spinner-holder">
      <mat-spinner data-cy="forms-form-loading-spinner"></mat-spinner>
    </div>
  </div>
</div>